import React from "react";
import { Switch } from "@whatslly/ui-components/v2/BaseElements/Switch";
import { useTranslation } from "react-i18next";
import styles from "./sharedStyles.module.scss";
import { DefaultUserChannels, DefaultUserChannelsName } from "./DefaultUserChannels";
import type { OrgConfigs } from "@whatslly/types/OrgConfigs";

interface InviteDesktopExtensionsSwitchProps {
  value: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
  orgConfigs: OrgConfigs | undefined;
  updateDefaultChannels: (channel: DefaultUserChannelsName, enabled: boolean) => void;
}

export const InviteDesktopExtensionsSwitch: React.FC<InviteDesktopExtensionsSwitchProps> = ({
  value,
  onChange,
  disabled,
  orgConfigs,
  updateDefaultChannels,
}) => {
  const { t } = useTranslation();

  return (
    <div>
      <div className={styles.switchTextContainer}>
        <Switch testId="invite_to_desktop_and_extensions_switch" checked={value} onChange={(e) => onChange(e.target.checked)} disabled={disabled} />
        <span>{t("users_management.invite_to_desktop_and_extensions")}</span>
      </div>
      {value && (
        <div className={styles.defaultChannels}>
          <DefaultUserChannels orgConfigs={orgConfigs} selectedChannels={undefined} updateDefaultChannels={updateDefaultChannels} />
        </div>
      )}
    </div>
  );
};
